import { Component, Input, OnInit } from '@angular/core';
import { EventsService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-referral-how-it-works',
  templateUrl: './referral-how-it-works.component.html',
  styleUrls: ['./referral-how-it-works.component.scss']
})
export class ReferralHowItWorksComponent implements OnInit {

  constructor(
    public utilService: UtilService,
    private eventsService: EventsService,
    public vars: VariablesService
  ) { }

  isMobile: any;
  breakpoints = {
    1920: {
      perView: 1.5,
      showArrows: false
    },
    1440: {
      perView: 1.2,
      showArrows: false
    },
    1536: {
      perView: 1.2,
      showArrows: false
    },
    1366: {
      perView: 1.2,
      showArrows: false
    },
    1280: {
      perView: 1.2,
      showArrows: false
    },
    1080: {
      perView: 1.2,
      showArrows: false
    },
    600: {
      perView: 1,
      showArrow: false
    }
  };

  @Input() howItWorksInfo = [
    {
      id: 1,
      subTitle: 'Automatic monthly donations',
      desc: {
        desk: 'Your monthly donation will be successfully matched to a patient in urgent need of a life-saving treatment',
        mob: null
      },
      buttonLabel: 'Donate Monthly',
      images: [
        { id: 1, url: null, text: 'Jan' },
        { id: 2, url: null, text: 'Feb' },
        { id: 3, url: null, text: 'Mar' },
        { id: 4, url: null, text: 'Apr' },
        { id: 5, url: null, text: 'May' },
        { id: 6, url: null, text: 'Jun' },
        { id: 7, url: null, text: 'Jul' },
        { id: 8, url: null, text: 'Aug' },
        { id: 9, url: null, text: 'Sept' },
      ]
    },
    {
      id: 2,
      subTitle: 'Complete Transparency on your Donations',
      desc: {
        desk: 'We will ensure that every donation reaches the patient each month',
        mob: null
      },
      buttonLabel: 'Gift A Life',
      images: [
        { id: 1, url: 'masked-boy.png', text: null },
      ]
    },
    {
      id: 3,
      subTitle: 'Receive monthly updates',
      desc: {
        desk: 'You will come to know about the impact of your donation & the life you saved',
        mob: 'You will come to know about the impact your donation had on someone and the life you saved.'
      },
      buttonLabel: 'Gift A Life',
      images: [
        { id: 1, url: 'laptop-work.png', text: null },
      ]
    }
  ];
  @Input() showPaymentBtn = false;
  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  /**
   * When carousel button is clicked
   */
  onPaymentClick(): void {
    this.eventsService.sendSystemEvent({
      eventName: 'give_monthly_new',
      info_1: 'position',
      info_2: '45',
      info_3: 'impact',
      page_name: this.vars.pageName
    }).subscribe(_ => _);
  }
}
